import styled from "styled-components";

import * as Table from "ds/Table";

export const LogsTableWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
  margin-top: 24px;
`;

export const LogsTable = styled.div``;

export const TableTr = styled(Table.Tr)`
  alignitems: flex-start;

  border-bottom: 1px solid var(--mode-border-neutral-weakest);
  align-items: start;

  &:hover {
    background-color: ${"var(--mode-bg-neutral-weaker)"};
    box-shadow: none;
  }
`;

export const LogAttributesList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: fit-content;
  gap: 6px;
  margin: 5px;
  font-size: 12px;
  line-height: 12px;
  max-width: 450px;
  cursor: default;
`;

export const LogAttribute = styled.div`
  display: flex;
  padding: 2px;
`;

export const LogAttributeHeader = styled.span`
  flex: 1;
  display: flex;
`;

export const LogAttributeKey = styled.span`
  color: ${"var(--mode-text-neutral-default-weak)"};
  font-family: ${"var(--ff-sans)"};
  font-size: ${"var(--fs-s)"};
  font-style: normal;
  font-weight: 600;
`;

export const LogAttributeSeparator = styled.span`
  flex: 1;
  width: 100%;
  border-bottom: 1px solid ${"var(--theme-neutral-200)"};
  margin: 0px 10px 8px 10px;
`;

export const LogAttributeValue = styled.span`
  flex: 1;
  padding: 4px;

  span {
    border-radius: 4px;
    padding: 4px;
    background-color: ${"var(--mode-bg-primary-weakest)"};
    font-family: ${"var(--ff-mono),monospace"};
  }
`;

export const LogsFooter = styled.span`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1em;
`;

export const ExpandedLogLine = styled.div`
  width: 100%;
`;

export const LogContent = styled.span`
  cursor: pointer;
  width: 100%;
`;

export const LogContentWrapper = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ActionItem = styled.span`
  cursor: pointer;
`;
